import EnhancedPortfolioPro from "./EnhancedPortfolio";

export default function App() {
  return <EnhancedPortfolioPro />;
}
